import { render, staticRenderFns } from "./ColorVariationItem.vue?vue&type=template&id=786d3753"
import script from "./ColorVariationItem.vue?vue&type=script&lang=js"
export * from "./ColorVariationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports